import React from 'react'
import ContactsContainer from './ContactsContainer'

const Contacts = (props) => (
  <ContactsContainer {...props} />
)

export default Contacts



// WEBPACK FOOTER //
// ./src/routes/Contacts/index.js